var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "2 2 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20C22 20.5523 21.5523 21 21 21C20.4477 21 20 20.5523 20 20V4C20 3.44772 20.4477 3 21 3C21.5523 3 22 3.44772 22 4V20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2929 17.7071C9.90237 17.3166 9.90237 16.6834 10.2929 16.2929L13.5858 13L3 13C2.44771 13 2 12.5523 2 12C2 11.4477 2.44771 11 3 11L13.5858 11L10.2929 7.70711C9.90237 7.31658 9.90237 6.68342 10.2929 6.29289C10.6834 5.90237 11.3166 5.90237 11.7071 6.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L11.7071 17.7071C11.3166 18.0976 10.6834 18.0976 10.2929 17.7071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.ff7c831e.svg";
export { ForwardRef as ReactComponent };